import DeliverySVG from "@design-system/ui-icons/vanilla/Delivery"
import { createIcon } from "../createIcon"

export const DeliveryIcon = createIcon(DeliverySVG)
